import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { hasRole } from '@heyjob-dash/shared/utils/check-permission';

import { paths } from 'src/routes/paths';

import { useAuthContext } from '../hooks';

// ----------------------------------------------------------------------

// Gate rotte riservate a uno o più ruoli Cognito (es. solo 'Azienda').
// Complementa il gate UI (menu/header); qui blocca l'accesso via URL diretto.
export default function RoleGuard({ roles, children }) {
  const { loading, user } = useAuthContext();

  if (loading) {
    return null;
  }

  if (!hasRole(user, roles)) {
    return <Navigate to={paths.dashboard.root} replace />;
  }

  return <>{children}</>;
}

RoleGuard.propTypes = {
  roles: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  children: PropTypes.node,
};
